
import React from 'react';
import { CustomerData } from '@/hooks/admin/types';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

interface UserStatsProps {
  customers: CustomerData[];
  planFilter: string | null;
  onFilterChange: (plan: string | null) => void;
  stats: {
    totalUsers: number;
    pendingUsers: number;
    monthlyUsers: number;
    annualUsers: number;
    lifetimeUsers: number;
    cancelledUsers: number;
  };
}

const UserStats: React.FC<UserStatsProps> = ({ 
  customers, 
  planFilter, 
  onFilterChange,
  stats 
}) => {
  // Use the pre-calculated stats
  const { totalUsers, pendingUsers, monthlyUsers, annualUsers, lifetimeUsers, cancelledUsers } = stats;
  
  console.log("UserStats component received stats:", stats);

  const handleFilterClick = (plan: string | null) => {
    if (planFilter === plan) {
      // If clicking on already active filter, clear it
      onFilterChange(null);
    } else {
      // Apply new filter
      onFilterChange(plan);
    }
  };

  const renderStat = (label: string, count: number, filterValue: string | null) => {
    const isActive = planFilter === filterValue;
    
    return (
      <Button 
        variant={isActive ? "default" : "ghost"} 
        size="sm"
        className={`h-auto py-1 px-3 font-normal ${isActive ? '' : 'hover:bg-secondary'}`}
        onClick={() => handleFilterClick(filterValue)}
      >
        {label}: <span className="font-medium ml-1">{count}</span>
        {isActive && <X className="h-3 w-3 ml-1" />}
      </Button>
    );
  };

  return (
    <div className="flex flex-wrap gap-2 mb-4 items-center">
      {renderStat("Total Users", totalUsers, null)}
      {renderStat("Pending", pendingUsers, "pending")}
      {renderStat("Monthly", monthlyUsers, "monthly")}
      {renderStat("Annual", annualUsers, "annual")}
      {renderStat("Lifetime", lifetimeUsers, "lifetime")}
      {renderStat("Cancelled", cancelledUsers, "canceled")}
      
      {planFilter && (
        <span className="text-xs text-muted-foreground ml-2">
          Showing {planFilter} users
        </span>
      )}
    </div>
  );
};

export default UserStats;
